import { Radio } from 'antd';
import './radio.less';

export default Radio;
